import * as React from 'react';
import ReactTable from 'react-table';
import {IContactNode, IEntityNode, IEntityWithContactsNodeResult} from "../types";
import {renderUrl} from "../utils/renderUrl";
import {customSort} from "../utils/customSort";

export enum QUERY_ACCESSORS {
    email = 'email',
    entityname = 'entityname'
}

type rowType = {
    pocid?: number;
    layername: string;
    entityname: string;
    websiteurl: string;
} & Partial<IContactNode>;

export class QueryTable extends React.Component<any, any> {
    constructor (props: any) {
        super(props);
        this.state = {
            data: this.props.data || []
        };
    }

    componentDidMount () {
        /**
         *
         * todo: separate into two components
         *
         * */
        const {queryId = 'cono-data'} = this.props.$stateParams;
        console.log(queryId);
        let data: Array<rowType> = [];
        const storedData = JSON.parse(localStorage.getItem(queryId) as string);
        // todo: better
        let i = -1;
        const length = storedData ? storedData.data.length : 0;
        const title = storedData ? storedData.title : '';
        while (++i < length) {
            const node: IEntityWithContactsNodeResult = storedData.data[i];
            if (node.entitycontactsByFullUid.nodes.length > 0) {
                data = data.concat(
                    node.entitycontactsByFullUid.nodes.map(contact => ({
                        ...contact.contactByPocid,
                        pocid: Number(contact.contactByPocid.pocid),
                        layername: node.layername,
                        entityname: node.name,
                        websiteurl: node.websiteurl
                    })) as rowType[]
                )
            } else {
                data.push({
                    layername: node.layername!,
                    entityname: node.name!,
                    websiteurl: node.websiteurl!
                })
            }

        }
        try {
            const sorted = data.slice().sort(
                (a, b) =>
                    customSort(a.entityname, b.entityname)
            );
            data = sorted;
        } catch (e) {
            console.error(e);
        }
        this.setState({
            title,
            data
        });
        localStorage.removeItem(queryId);
    }

    copyColumn = (accessor: string) => {
        let joinChar;
        switch (accessor) {
            case QUERY_ACCESSORS.email:
                joinChar = ';';
                break;
            case QUERY_ACCESSORS.entityname:
            default:
                joinChar = ';';
        }
        const newClip = this.state.data.map((d: IEntityNode) => d[accessor]).join(joinChar);
        navigator.clipboard.writeText(newClip).then(function() {
            /* clipboard successfully set */
            console.info('Copied text ', newClip);
        }, function() {
            console.error('Failed to copy text ', newClip);
            /* clipboard write failed */
        });
    }

    renderHeader = (headerName: string, accessor: string) => {
        return <div>
            <span>{headerName} </span>
            <span className={`btn fas fa-copy`} title={'Copy Column'} onClick={() => this.copyColumn(accessor)}/>
        </div>
    }

    /**
     *
     *

     Layer Name,
     Entity Name,
     Entity Url,
     POC Name,
     POC Land,
     POC Cell,
     POC Email

     LayerName
     Website
     POC Name
     Cell
     Land
     Email

     * */

    render () {
        const { data, title } = this.state;
        return (
            <div>
                {title && <div>{title}</div>}
                <ReactTable
                    data={data}
                    defaultSorted={[
                        {
                            id: "entityname",
                            desc: false
                        }
                    ]}
                    columns={[
                        {
                            Header: "Layer",
                            accessor: "layername",
                            sortMethod: customSort
                        },
                        {
                            Header: this.renderHeader('Name', QUERY_ACCESSORS.entityname),
                            accessor: "entityname",
                            id: "entityname",
                            sortMethod: customSort
                        },
                        {
                            Header: 'Website',
                            accessor: "websiteurl",
                            Cell: props => renderUrl(props.value, '', '', '', false)
                        },
                        {
                            Header: "POC Name",
                            accessor: "name",
                            sortMethod: customSort
                        },
                        {
                            Header: "Cell",
                            accessor: "cell",
                        },
                        {
                            Header: "Land",
                            accessor: "land",
                        },
                        {
                            Header: this.renderHeader('Email', QUERY_ACCESSORS.email),
                            accessor: "email",
                            sortMethod: customSort
                            // Cell: props => renderUrl(props.value, '', '', '', false)
                        }
                    ]}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />
                <br />
            </div>
        );
    }
}
